<div mat-dialog-title class="dialog-header d-flex justify-content-between">
  <div i18n="@@changePassword">Change Password</div>
  <mat-icon (click)="closeDialog()" class="cursor" i18n-aria-label="@@closeDialog" aria-label="Close">close</mat-icon>
</div>

<mat-dialog-content>
  <form [formGroup]="changePasswordForm">
    <div class="form-group">
      <mat-form-field class="w-100" appearance="outline">
        <mat-label i18n="@@oldPasswordLabel">Old password</mat-label>
        <input data-testid="change_password_old" type="password" matInput id="old_password" i18n-placeholder="@@oldPasswordPlaceholder" placeholder="Old password" name="old_password" formControlName="old_password" required />
        <mat-error>
          @if (!changePasswordForm.get('old_password').valid && changePasswordForm.get('old_password').touched) {
            @if (changePasswordForm.get('old_password').errors && changePasswordForm.get('old_password').errors['required']) {
              <span i18n="@@inValidRequiredField">This field is required</span>
            }
          }
        </mat-error>
      </mat-form-field>
    </div>

    <div class="form-group">
      <mat-form-field class="w-100" appearance="outline">
        <mat-label i18n="@@newPasswordLabel">New password</mat-label>
        <input data-testid="change_password_new" #password [type]="hide ? 'password' : 'text'" matInput id="new_password" i18n-placeholder="@@inValidPasswordPlaceholder" placeholder="Password should be at least 8 alphanumeric characters" name="new_password" formControlName="new_password" required />
        <mat-hint align="end" [class]="meterMessage" >
          {{meterMessage}}
        </mat-hint>
        <mat-icon class="cursor" matSuffix (click)="hide = !hide" i18n-aria-label [attr.aria-label]="hide ? 'Show password' : 'Hide password'">
          {{hide ? 'visibility' : 'visibility_off'}}
        </mat-icon>
        <mat-error>
          @if (!changePasswordForm.get('new_password').valid && changePasswordForm.get('new_password').touched) {
            @if (changePasswordForm.get('new_password').errors['required']) {
              <span i18n="@@inValidRequiredField">This field is required</span>
            }
          }
          @if (changePasswordForm.get('new_password').errors && changePasswordForm.get('new_password').errors['pattern']) {
            <span i18n="@@inValidPassword">Password should be at least 8 alphanumeric characters!</span>
          }
        </mat-error>
      </mat-form-field>
    </div>

    <div style="display: none">
      <password-strength-meter
        *ngIf="changePasswordForm?.get('new_password')"
        [password]="changePasswordForm.get('new_password').value"
        (strengthChange)="onStrengthChanged($event)">
      </password-strength-meter>
    </div>

    <div>
      <button i18n="@@changePassword" data-testid="change_password_button" class="w-100" mat-raised-button color="primary" (click)="onSubmit()">Change Password</button>
    </div>
  </form>
</mat-dialog-content>